import { addStyles } from 'ethcss'
import { radiusSizes } from 'blocks.app/config'
import { colors, grid, IStyles, item, mediaCSS } from '../../theme'

const updateDevicesStyles: IStyles = {
    wrapper: {
        ...grid.hspace,
        ...item.white,
        borderRadius: radiusSizes.mini,
    },
    tabs: {
        ...grid.row,
        width: '100%',
        borderRadius: radiusSizes.mini,
    },
    stepsWrapper: {
        [mediaCSS.tabMini]: {
            position: 'fixed',
            width: 'calc(100% - 28px)',
        },
    },
    title: {
        ...grid.p_md,
        ...grid.pb_none,
        ...grid.mt_micro,
    },
    tasksList: {
        ...grid.pb_mdPlus,
        ...grid.mt_md,
        ...grid.space,
        [mediaCSS.tabMini]: {
            marginTop: 80,
        },
    },
    settings: {
        ...grid.row,
        ...grid.p_md,
        ...grid.pr_mdPlus,
        ...grid.pl_mdPlus,
    },
    updateDevicesUpdateDateWrapper: {
        ...grid.w20,
        ...grid.mr_big,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mr_none,
            ...grid.mb_md,
        },
    },
    updateDevicesQueue: {
        paddingLeft: 30,
        width: 'calc(40% + 44px)',

        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    updateDevicesUpdateTimeWrapper: {
        ...grid.w20,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mb_md,
        },
    },
    updateDevicesUpdateNowCheckboxWrapper: {
        ...grid.flexEnd,
        [mediaCSS.tabMini]: {
            ...grid.flexStart,
        },
        ...grid.pb_micro,
    },
    updateDevicesUpdateNowCheckbox: {
        ...grid.ml_big,
        [mediaCSS.tabMini]: {
            ...grid.ml_none,
        },
    },
    updateDevicesPlatformWrapper: {
        ...grid.col,
        ...grid.w45,
        ...grid.pr_md,
        ...grid.pb_md,
        [mediaCSS.mob]: {
            ...grid.w100,
            ...grid.pr_none,
        },
    },
    updateDevicesUpdateButtonWrapper: {
        ...grid.row,
        ...grid.fullWidth,
        ...grid.center,
        ...grid.mt_mdPlus,
        [mediaCSS.tabMini]: {
            ...grid.mt_mini,
        },
    },
    updateDevicesRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        width: 'calc(40% + 44px)',
        marginBottom: 20,
        [mediaCSS.tab]: {
            width: '100%',
        },
    },
    updateDevicesCol: {
        width: '45%',
        marginTop: 20,
    },
    updateType: {
        width: '100%',
    },
    help: {
        fontSize: 12,
        color: colors.grey,
        marginTop: 8,
    },
    updateTypeWrapper: {
        width: '20%',
        [mediaCSS.tab]: {
            width: '50%',
        },
        [mediaCSS.mob]: {
            width: '100%',
        },
    },
}

addStyles(updateDevicesStyles)
export default updateDevicesStyles
